<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
    <path d="M48.4335 55.7859L18.5363 69.0675L20.7915 36.4307L37.5808 23.7791L54.5799 35.682L48.4335 55.7859Z" stroke="#00529A" stroke-width="2"/>
    <circle cx="34.8966" cy="44.9706" r="5.71605" transform="rotate(35 34.8966 44.9706)" stroke="#00529A" stroke-width="2"/>
    <path d="M17.9057 69.9679L31.6291 50.3689" stroke="#00529A" stroke-width="2"/>
    <rect x="39.1356" y="15.3146" width="28.2222" height="7.23457" transform="rotate(35 39.1356 15.3146)" stroke="#00529A" stroke-width="2"/>
    <rect x="40.8878" y="7.99331" width="34.0988" height="7.23457" transform="rotate(35 40.8878 7.99331)" stroke="#00529A" stroke-width="2"/>
    <path d="M18 70H71" stroke="#00529A" stroke-width="2"/>
  </svg>
</template>
